module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"more":"Ще 0 вакансій компанії | Ще {n} вакансія компанії | Ще {n} вакансії компанії | Ще {n} вакансій компанії"},"en":{"more":"0 company vacancies | {n} company vacancy | {n} company vacancies"}}')
  delete Component.options._Ctor
}
